import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

export type AmplitudeAiResponseStatus = "success" | "error";

interface ITrackAmplitudeAiResponseParams {
    modalSize: AmplitudeSemanticSearchModalSize | null;
    analyticSessionId: string | null | undefined;
    responseStatus: AmplitudeAiResponseStatus;
}

export const trackAmplitudeAiResponse = ({modalSize, analyticSessionId, responseStatus}: ITrackAmplitudeAiResponseParams): void => {
    trackAmplitudeEvent("ai_response", {
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize,
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
        response_status: responseStatus
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

export type AmplitudeAiResponseStatus = "success" | "error";

interface ITrackAmplitudeAiResponseParams {
    modalSize: AmplitudeSemanticSearchModalSize | null;
    analyticSessionId: string | null | undefined;
    responseStatus: AmplitudeAiResponseStatus;
}

export const trackAmplitudeAiResponse = ({modalSize, analyticSessionId, responseStatus}: ITrackAmplitudeAiResponseParams): void => {
    trackAmplitudeEvent("ai_response", {
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize,
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
        response_status: responseStatus
    });
};
